import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/villa.png";

import projImg4 from "../assets/img/project-img4.png"

import ladidi from "../assets/ladidi.png"
import merch from "../assets/merch.png"
import lixnet from "../assets/lixnet.png"
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {
const projects = [
  {
    title: "Ladidi",
    description: "Blog site",
    imgUrl: ladidi,
    videoUrl: null,
    techstack: ["HTML", "CSS", "Django"],
    linkUrl: "https://ladidi.co.ke/",
  },

  {
    title: "MerchPA",
    description: "Merchandiser Platform",
    imgUrl: merch,
    videoUrl: null,
    techstack: ["ReactJS", "Redux", "Flask"],
    linkUrl: "https://merchp-a-1.onrender.com/",
  },

   {
    title: "Perfume Gala",
    description: "Perfume Website",
    imgUrl: projImg4,
    videoUrl: null,
    techstack: ["React", "TailwindCSS"],
    linkUrl: "https://perfume-gala.vercel.app/",
  },

  {
    title: "Lixnet",
    description: "Software Solutions",
    imgUrl: lixnet,
    videoUrl: null,
    techstack: ["React", "Laravel"],
    linkUrl: "https://lixnet.net/",
  },
  
 

   {
    title: "VillaBnb",
    description: "Airbnb website",
    imgUrl: projImg1,
    videoUrl: null,
    techstack: ["React", "Flask"],
    linkUrl: "https://villa-bnb-drop.onrender.com/",
  },
  
];


  return (
    <section className="bg-gradient-to-b from-gray-100 to-gray-200 project overflow-y-hidden" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2 className="text-black">Projects</h2>
                
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                  
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="projects"></img>
    </section>
  )
}
